import React from 'react';
import './ServicesCTA.css';

export function ServicesCTA() {
  return (
    <section className="services-cta">
      <div className="services-cta-background">
        <div className="light-beam light-beam-1"></div>
        <div className="light-beam light-beam-2"></div>
        <div className="light-beam light-beam-3"></div>
      </div>

      <div className="services-cta-content">
        <div className="cta-badge">
          <span>Ready to Transform?</span>
        </div>
        <h2 className="services-cta-title">
          Let's Build the Future Together
        </h2>
        <p className="services-cta-subtitle">
          Partner with SFrays for innovative solutions that drive measurable results.<br />
          Your digital transformation journey starts here.
        </p>
        <div className="services-cta-actions">
          <button className="btn btn-primary cta-btn">Start Your Project</button>
          <button className="btn btn-secondary cta-btn">Talk to an Expert</button>
        </div>

        <div className="cta-stats">
          <div className="stat-item">
            <div className="stat-number">500+</div>
            <div className="stat-label">Projects Delivered</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">98%</div>
            <div className="stat-label">Client Satisfaction</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Expert Support</div>
          </div>
        </div>
      </div>
    </section>
  );
}
